/**
 * Легенда карты.
 */

import type { LocaleCode } from "@hive/i18n";
import { useTranslation } from "react-i18next";

import { COLORS } from "../map/style.js";

export interface LegendProps {
  readonly locale: LocaleCode;
  readonly hexesVisible: boolean;
}

const LEGEND_ROWS: ReadonlyArray<{ color: string; key: string }> = [
  { color: COLORS.you, key: "legend.yours" },
  { color: COLORS.clan, key: "legend.clan" },
  { color: COLORS.ally, key: "legend.ally" },
  { color: COLORS.enemy, key: "legend.enemy" },
  { color: COLORS.free, key: "legend.free" },
  { color: COLORS.sanctuary, key: "legend.sanctuary" },
];

export function Legend({ hexesVisible }: LegendProps): React.JSX.Element {
  const { t } = useTranslation(["map"]);

  return (
    <aside className="legend">
      <h2 className="legend__title">{t("map:legend.title")}</h2>
      <ul className="legend__list">
        {LEGEND_ROWS.map((row) => (
          <li key={row.key} className="legend__row">
            <span className="legend__swatch" style={{ backgroundColor: row.color }} />
            <span>{t(`map:${row.key}`)}</span>
          </li>
        ))}
      </ul>

      {!hexesVisible && <p className="legend__hint">{t("map:zoom.hint")}</p>}
      {hexesVisible && <p className="legend__hint">{t("map:select.hint")}</p>}
    </aside>
  );
}
